import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-clienti',
  standalone: false,
  templateUrl: './clienti.component.html',
  styleUrl: './clienti.component.scss'
})

export class ClientiComponent implements OnInit  {
  user_id:number=0;
  constructor(
      private apiService: ApiService,
      public globalService : GlobalService,
   
    ) { }
    
  ngOnInit(): void {  
    this.user_id=this.globalService.getUser().id;
  }

}
